module.exports = __webpack_public_path__ + "static/media/VectorType.2d44c296.svg";